import { useEffect, useState } from 'react'
import { ModalStore } from '../../state/ModalStore'
import ModalContent from './ModalContent'
import ModalContentWrapper from './ModalContentWrapper'
import ModalFooter from './ModalFooter'
import ModalHeader from './ModalHeader'
import ModalMainWrapper from './ModalMainWrapper'

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

const flyerSwatchStyle = (value) => {
    const normalized = String(value || '').toLowerCase()

    if (normalized.includes('parchment')) {
        return {
            background: 'linear-gradient(135deg,#fbf3e0,#f1e4c6)',
        }
    }
    if (normalized.includes('abstract')) {
        return {
            background:
                'conic-gradient(from 200deg at 32% 30%,#f6d9c2,#fde7c0,#e7eef7,#f3dfe9,#f6d9c2)',
        }
    }
    if (normalized.includes('beach')) {
        return {
            background:
                'linear-gradient(180deg,#cfeaf4 0%,#e8f3ee 50%,#f4e7c6 51%,#efddb6 100%)',
        }
    }
    if (normalized.includes('flag')) {
        return {
            background:
                'linear-gradient(135deg,#ccd8ef 0 38%,rgba(0,0,0,0) 38%) top left / 42% 52% no-repeat, repeating-linear-gradient(180deg,#f6e3e0 0 9px,#fff 9px 18px)',
        }
    }
    if (normalized.includes('woodgrain')) {
        return {
            background:
                'repeating-linear-gradient(92deg,#e7cfa8 0 7px,#dcc096 7px 12px,#e3c9a0 12px 19px)',
        }
    }

    return { background: 'linear-gradient(135deg,#fbf3e0,#f1e4c6)' }
}

export default function FlyerStyleModal({
    item,
    getValues,
    setValue,
    afterSelection,
}) {
    const skimModal = ModalStore((state) => state.skim)
    const [selected, setSelected] = useState(getValues(item.name) || '')

    useEffect(() => {
        setSelected(getValues(item.name) || '')
    }, [getValues, item.name])

    const handleConfirm = () => {
        if (!selected) return
        setValue(item.name, selected)
        afterSelection?.(selected)
        skimModal()
    }

    return (
        <ModalMainWrapper>
            <ModalContentWrapper size="3xl" spacing="normal">
                <ModalHeader title="Choose a flyer style" />
                <ModalContent spacing="normal" scroll={true}>
                    <div className="grid gap-3 sm:grid-cols-5">
                        {item.options.map((option) => (
                            <button
                                key={option}
                                type="button"
                                onClick={() => setSelected(option)}
                                className={classNames(
                                    selected === option
                                        ? 'border-[#F28230] shadow-[0_0_0_3px_rgba(242,130,48,0.16)]'
                                        : 'border-[#E1DACE]',
                                    'overflow-hidden rounded-xl border-[1.5px] bg-white text-left transition-all duration-150 hover:border-[#F6D9C2]',
                                )}>
                                <div
                                    className="h-[100px] w-full"
                                    style={flyerSwatchStyle(option)}
                                />
                                <div className="px-3 py-2 text-center text-[13px] font-semibold text-olm-black">
                                    {option}
                                </div>
                            </button>
                        ))}
                    </div>
                </ModalContent>
                <ModalFooter
                    confirmText="Select flyer style"
                    onConfirm={handleConfirm}
                />
            </ModalContentWrapper>
        </ModalMainWrapper>
    )
}
